// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__284bl","pic":"App_pic__3xc_u","image":"App_image__1BtP_"};